export default "__VITE_ASSET__D_0UiZCp__"